<template>
  <div>
    <LayoutHeader
      activeNav="艺讯"
      :topColor="topColor"
      bannerType="header artInfo"
      :height="380"
    />
    <div class="container">
      <section class="top">
        <h1>首页&lt;艺讯&lt;正文</h1>
        <h2>
          {{ news_detail.name }}
        </h2>
        <h3>
          <span style="margin-right: 70px">发布时间：{{ news_detail.cd }}</span>
          <span v-if="news_detail.source" style="margin-right: 30px">来源：{{ news_detail.source }}</span>
          <span v-if="news_detail.author">作者： {{ news_detail.author }}</span>
        </h3>
      </section>
      <section class="bottom">
        <!-- 新闻内容，富文本 -->
        <div class="left" v-html="news_detail.content"></div>
        <div class="right">
          <div class="hot">
            <h1>热门推荐<span>{{hot_time}}</span></h1>
            <ul>
              <li v-for="(hot_item, hot_index) in hot_news" :key="hot_index" style="cursor: pointer;" @click="newsDetail(hot_item.id)">
                <div class="index">{{ hot_index + 1 }}</div>
                <div style="margin-right: 10px; width: 190px">
                  {{ hot_item.name }}
                </div>
                <img
				  v-if="hot_item.img_cover_full==''"
                  src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=869747648,901733107&fm=26&gp=0.jpg"
                  alt=""
                />
				<img
				  v-if="hot_item.img_cover_full"
				  :src="hot_item.img_cover_full"
				  alt=""
				/>
              </li>
            </ul>
          </div>
          <div class="more">
            <div>
              <h1>更多艺讯</h1>
              <span @click="toMore">查看更多&gt;&gt;</span>
            </div>

            <ul>
              <li
                v-for="(more_item, more_index) in more_news"
                :key="more_index"
              >
                <i></i>
                <span @click="newsDetail(more_item.id)">{{ more_item.name }}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import newsServices from "../../xx-vue/services/news";
export default {
  data() {
    return {
      topColor: "",
      news_detail: {
        name: "",
      },
      hot_news: [], //热门推荐
      more_news: [], //更多新闻
      hot_time: "",
    };
  },
  mounted() {
    this.initScroll();
    this.initData(this.$route.query.id);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
	//新闻跳转
	newsDetail(id){
		this.initData(id);
	},
    //初始化数据
    async initData(id) {
      const result = await newsServices.getDetailAsync({ id: id });
      this.news_detail = result.data;
      const dateArr = this.news_detail.cd.split(" ")[0].split("-");
      const timeArr = this.news_detail.cd.split(" ")[1].split(":");
      const date =
        dateArr[0] +
        "年" +
        dateArr[1] +
        "月" +
        dateArr[2] +
        "日" +
        " " +
        timeArr[0] +
        ":" +
        timeArr[1];
      this.news_detail.cd = date;

      const hotResult = await newsServices.getNewsAsync({
        is_hot: 1,
        limit: 4,
      });
      const moreResult = await newsServices.getNewsAsync({
        is_hot: 0,
        limit: 4,
      });
      this.hot_news = hotResult.data.list;
      this.more_news = moreResult.data.list;
      this.hot_time = new Date(parseInt(hotResult.data.time) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
      this.hot_time =
        this.hot_time.split(" ")[0].replace(/\//g, ".") +
        " " +
        this.hot_time.split(" ")[1];
    },
    //查看更多
    toMore() {
      this.$router.push("/art_info");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 48px 0;
  width: 1200px;
  margin: 0 auto;
  .top {
    h1 {
      font-size: 20px;
      font-weight: normal;
      color: #333333;
      margin-bottom: 38px;
    }

    h2 {
      font-size: 32px;
      color: #333333;
      margin-bottom: 50px;
    }

    h3 {
      color: #bbbbbb;
      font-size: 14px;
      font-weight: normal;
      padding-bottom: 36px;
      border-bottom: 1px solid #dddddd;
    }
  }

  .bottom {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 65%;
    }
    .right {
      width: 30%;
      .hot {
        h1 {
          padding: 0 18px;
          font-size: 18px;
          color: #a32225;
          padding-bottom: 16px;
          border-bottom: 1px solid #dddddd;
          span {
            font-size: 14px;
            color: #989898;
            margin-left: 6px;
            font-weight: normal;
          }
        }

        ul {
          margin-bottom: 32px;
          li {
            display: flex;
            padding: 10px;
            align-items: center;
            img {
              width: 120px;
              height: 80px;
            }

            .index {
              font-size: 36px;
              color: #dddddd;
              margin-right: 10px;
            }
          }
        }
      }

      .more {
        & > div {
          padding: 0 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          h1 {
            font-size: 18px;
            color: #333333;
          }
          span {
            font-size: 14px;
            color: #989898;
            cursor: pointer;
          }
        }

        ul {
          margin-top: 12px;
          margin-bottom: 200px;
          border: 1px solid #dddddd;
          li {
            padding: 26px 32px;
            display: flex;
            align-items: center;
            i {
              display: block;
              width: 10px;
              height: 10px;
              background-color: #a32225;
              margin-right: 16px;
            }
            span {
              color: #333333;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
              cursor: pointer;
            }
          }

          & > :not(:last-child) {
            border-bottom: 1px solid #dddddd;
          }
        }
      }
    }
  }
}
</style>